function detectSupportPictureElement() {
  const support = !!window.HTMLPictureElement
  if (!support) {
    document.documentElement.classList.add('no-support-picture')
  }
}

export default detectSupportPictureElement
